
import "./Work.css"


const Work = ({MyData}) => {

  
  console.log(MyData)
  return (
    <>

      <h3 className='text-center mt-5 mb-5 hr-lines' id="projects">Recent Projects</h3>
     
      <div className="container">
  <div className="row">
      {MyData.map((curElement)=>{
return (
  <>
   
    <div className="col-lg-3 col-md-3 col-sm-12">
      <div className="card p-3">
        <span className="no d-none">{curElement.id}</span>

        <img src={curElement.img} alt="project" className="p-3 h-50" />
        <div class="card-body">
          <h5 className="card-title text-center">{curElement.title}</h5>
          <p className="card-text mb-3">{curElement.content}</p>
          <center>
            <button href="abc" className="button p-3">
              <span>View </span>
            </button>
          </center>
        </div>
      </div>
    </div>
    <div className="col-lg-1"></div>
  </>
);})}

      
  
</div>
</div>
    


    </>
  )
}

export default Work
